import { isAllowedInCountry } from "@/lib/country-gates"
import type { Country } from "@/i18n/config"

/**
 * Which "how would you like to reach us" cards /contact offers in a market.
 * Chat is always there; the others depend on what the market actually staffs.
 */
export function contactIntentOptions(country: Country) {
  // Discovery-call booking is gated out of NL (waitlist phase) — same
  // page:free-call gate as the /free-call page and the bottom CTA.
  const showBookCall = isAllowedInCountry("page:free-call", country)
  // Prominent phone (hero link + "Call us" card) is CH-only — real staffed
  // Swiss line; other markets have no staffed number / placeholder data.
  const showPhone = isAllowedInCountry("section:contact.phone", country)
  // WhatsApp runs on the Swiss support number (MARKET_SUPPORT.at reuses it),
  // so it stays off on AT until Austria has its own line.
  // country-gate-ignore: AT content hide, not a page gate
  const showWhatsApp = country !== "at"
  // AT has none of the three above, so email gets its own card next to chat;
  // the form follows below (AHD-13711).
  // country-gate-ignore: AT content shape, not a page gate
  const showEmailCard = country === "at"
  const cardCount =
    1 +
    (showWhatsApp ? 1 : 0) +
    (showBookCall ? 1 : 0) +
    (showPhone ? 1 : 0) +
    (showEmailCard ? 1 : 0)
  return {
    showBookCall,
    showPhone,
    showWhatsApp,
    showEmailCard,
    cardCount,
    // A lone card isn't a choice — a market left with chat only drops the
    // section and the email form follows the hero.
    showIntentSection: cardCount > 1,
  }
}
